/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Archival_Results_Has_PlayInputs */



/**
* | output |
* | --- |
* | "This event has recorded results — correct them through the rounds and finals" |
*
* @param {Err_Tournament_Archival_Results_Has_PlayInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_archival_results_has_play = /** @type {((inputs?: Err_Tournament_Archival_Results_Has_PlayInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Archival_Results_Has_PlayInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cet événement a des résultats enregistrés — corrigez-les via les rondes et la finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este evento tiene resultados registrados — corrígelos mediante las rondas y la final")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este evento tem resultados registrados — corrija-os pelas rodadas e pela final")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo evento ha risultati registrati — correggili tramite i turni e la finale")
	return /** @type {LocalizedString} */ ("This event has recorded results — correct them through the rounds and finals")
});